module.exports = __webpack_public_path__ + "img/logo.1471220c.png";